<div
  class="qr-wrapper"
  *ngIf="id"
  fxFill
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="30px"
>
  <h1 i18n>SkyberTeam Safe Multi Factor Authentication</h1>
  <p i18n>
    Please scan the following QR Code from within the SafeMFA mobile app to
    register.
  </p>
  <ngx-qrcode [elementType]="elementType.IMG" [value]="id"></ngx-qrcode>
</div>
